export const formatDate = (date) => {
	let  dd 		= date.getDate().toString().padStart(2, '0');
	let  mm 		= (date.getMonth() + 1).toString().padStart(2, '0');
	let  yyyy 		= date.getFullYear();
	return`${yyyy}-${mm}-${dd}`;
}

export const fourDigitsYear = (twoDigitsYear) => {
    const date18YrsAgo = new Date();
    date18YrsAgo.setFullYear(date18YrsAgo.getFullYear() - 18)
    if (twoDigitsYear < date18YrsAgo.getFullYear().toString().slice(2, 4)) {
        return twoDigitsYear + 2000;
    } else {
        return twoDigitsYear + 1900;
    }
}

export const getCatalog = (catalog) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/bbva/get-catalogs/${catalog}`)
            .then((resp) => {
                const { success, data } = resp.data;
                if (success) {
                    // console.log("getCatalog", catalog, data.records);
                    resolve(data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    })
}

export const getEnum = (catalog) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/bbva/get-enum/${catalog}`)
            .then((resp) => {
                const { success, data } = resp.data;
                if (success) {
                    // console.log("getCatalog", catalog, data.records);
                    resolve(data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    })
}

export const getZipCodeCatalogs = (zipCode) => {
    return new Promise((resolve, reject) => {
        axios
            .post("/cotizadores/validate-zip-code", {
                zipCode
            })
            .then((resp) => {
                const { success, data } = resp.data;
                if (success) {
                    resolve(data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    })
}

export const getUniques = (arr, key) => {
    return [...new Map(arr.map(item => [item[key], item])).values()];
}

//capitalize only the first letter of the string. 
export const capFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatIntColor = (intColor) => {
    const intColorArray = intColor.split('_');
    let colorString = '';
    intColorArray.forEach((item, idx) => {
        colorString += idx === 0 ? capFirstLetter(item) : ` - ${capFirstLetter(item)}`;
    });
    return colorString;
}